import { Form } from 'antd';
import Box from 'components/Box';
import React from 'react';
import { IStaffListChooseUIRef, StaffListChooseUI } from './Staff';
import { IStaffItemData } from 'services/shop/types/staff';
import { IQuickBookingV2ServiceItem } from './type';
import OnHoldToggle from './OnHoldToggle';
import { IShopAllSetting } from 'services/shop/types/setting';
type Props = {
  staffRef: React.RefObject<IStaffListChooseUIRef>;
  onPickStaff: (item: IStaffItemData) => void;
  allSetting: IShopAllSetting | null;
};
const QuickBookingStaffContent = ({ staffRef, onPickStaff, allSetting }: Props) => {
  return (
    <Box
      display='flex'
      flexDirection='column'
      style={staffContainerStyle}
      mt='2'
    >
      <Form.Item hidden={!allSetting?.displayOnHoldBooking} name={'onHoldBooking'} noStyle>
        <OnHoldToggle />
      </Form.Item>
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const staffIds = getFieldValue('services')?.map(
            (o: IQuickBookingV2ServiceItem) => o.staffId
          );
          const staffs = getFieldValue('staffs');
          return (
            <StaffListChooseUI
              staffs={staffs}
              ref={staffRef}
              onPickStaff={onPickStaff}
              selectedStaffs={staffIds}
            />
          );
        }}
      </Form.Item>
    </Box>
  );
};

export default QuickBookingStaffContent;
const staffContainerStyle: React.CSSProperties = { minWidth: 750, overflow: 'auto' };